import { render, staticRenderFns } from "./assetrole.vue?vue&type=template&id=4d60e981&"
import script from "./assetrole.vue?vue&type=script&lang=js&"
export * from "./assetrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports